import localForage from 'localforage';
import { useTranslation } from 'react-i18next';
import { isObject, has, noop, cloneDeep } from 'lodash';
// Import Store
import { useAppDispatch } from 'store';
import { setHeaderLanguagesList } from 'store/slices/header';
// Import Services
import { UtilsHttpService } from 'services/http';
// Import Constants
import { SupportedLanguages } from 'constants/common';

export const useLocalization = () => {
    const { i18n } = useTranslation();
    const dispatch = useAppDispatch();

    const setInitialSelectedLanguage = (langId: string) => {
        for (let i = 0; i < SupportedLanguages.length; i++) {
            const language = SupportedLanguages[i];
            language.IsSelected = language.Id === langId;
        }

        dispatch(setHeaderLanguagesList(cloneDeep(SupportedLanguages)));
    };

    const setLocalization = async (langId: string, changeLanguageCallback = noop) => {
        setInitialSelectedLanguage(langId);

        UtilsHttpService.getTranslationsVersion().then(async (versionResponse) => {
            const originVersion = (versionResponse as unknown as { Data: string }).Data;

            const localizationResources = ((await localForage.getItem('localizationResources')) || {}) as {
                [key: string]: {
                    translations: { [key: string]: string };
                    version: string;
                };
            };
            const localVersion = has(localizationResources, langId) ? localizationResources[langId].version : '';
            const isVersionMatchWithLocal = localVersion === originVersion;

            if (isObject(localizationResources) && has(localizationResources, langId) && isVersionMatchWithLocal) {
                i18n.addResources(langId, 'translations', localizationResources[langId].translations);
                i18n.changeLanguage(langId).then(() => {
                    changeLanguageCallback(langId);
                });
            } else {
                if (!isObject(localizationResources) || !has(localizationResources, langId)) {
                    localizationResources[langId] = {
                        translations: {},
                        version: originVersion,
                    };
                }

                UtilsHttpService.getTranslations().then((res) => {
                    const { HasError, Data } = res as unknown as AnyObject;
                    if (!HasError) {
                        i18n.addResources(langId, 'translations', Data);
                        i18n.changeLanguage(langId).then(() => changeLanguageCallback(langId));
                        localizationResources[langId].translations = Data;
                        localizationResources[langId].version = originVersion;
                        localForage.setItem('localizationResources', localizationResources);
                    } else {
                        changeLanguageCallback(langId);
                    }
                });
            }
        });
    };

    return [setLocalization];
};
